module.exports = __webpack_public_path__ + "img/tech.b20f50d0.jpg";